import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend, configure } from 'vee-validate';
import rules from '@/helpers/rules';
import i18n from '@/i18n';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

configure({
  // this will be used to generate messages.
  defaultMessage: (_, values) => {
    return i18n.t(`Core.Errors.${values._rule_}`, values);
  },
});

// register global validation rules
Object.keys(rules).forEach(rule => extend(rule, rules[rule]));

// global mixin for additional functionality
Vue.mixin({
  rules() {
    return {};
  },
  mounted: function () {
    // register local validation rules
    const localRules = this.$options.rules.apply(this);
    Object.keys(localRules).forEach(rule => extend(rule, localRules[rule]));
  },
});
